<template>
  <v-container fill-height fluid style="margin-top: -10px;">

    <v-row class="text-center" justify="center" v-if="!showall">
        <v-col cols="12" style="max-width: 500px;">
          <p class="mb-1 heading2 text-center">{{ print('SSO_WEB.LOGIN.REDIRECTING_TEXT') }}</p>
        </v-col>
    </v-row>

    <v-row class="text-center" justify="center" v-if="showall">
        <v-col cols="12" style="max-width: 500px;">

            <div class="d-none d-sm-flex" style="height:64px;"></div>

            <v-row class="text-center" justify="center">
              <v-col cols="12" sm="12" align="center">
                <v-img
                  alt="VOYO Logo"
                  class="shrink mr-2"
                  contain
                  :src="require('@/assets/logos/voyo-2.png')"
                  transition="scale-transition"
                  height="48"
                />
              </v-col>
            </v-row>

            <v-row class="text-center" justify="center">
              <v-col cols="12" sm="12" v-if="flowType == 'AUTHORIZATION_CODE'">
                <p class="mb-3 heading1 text-center">{{ print('PARTNER.VOYO.SSO_WEB.ACCESS_TITLE') }}</p>
                <p class="mb-3 mt-3 heading1 text-center" style="border-bottom: 1px solid rgb(255,255,255,0.3); font-size:1px;">&nbsp;</p>
                <p class="mb-3 heading2 text-center">{{ print('PARTNER.VOYO.SSO_WEB.ACCESS_TEXT') }}</p>
              </v-col>
            </v-row>
            <v-row class="text-center" justify="center">
              <v-col cols="12" sm="12" v-if="flowType == 'DEVICE_CODE'">
                <p class="mb-3 heading1 text-center">{{ print('PARTNER.VOYO.SSO_WEB.PAIRING_TITLE') }}</p>
                <p class="mb-3 mt-3 heading1 text-center" style="border-bottom: 1px solid rgb(255,255,255,0.3); font-size:1px;">&nbsp;</p>
                <p class="mb-3 heading2 text-center">{{ print('PARTNER.VOYO.SSO_WEB.PIN_CODE_INFO') }}</p>
              </v-col>
            </v-row>
            <v-row class="text-center" justify="center">
              <v-col cols="12" sm="6" class="pt-0 pb-5" v-if="flowType == 'DEVICE_CODE'">
                <v-text-field clearable outlined :placeholder="print('PARTNER.VOYO.SSO_WEB.LOGIN.VERIFICATION_CODE')" v-model="user_code" :rules="userCodeRule" light background-color="white" color="#6C6C6C" hide-details="auto"
                  @input="(val) => (user_code = user_code.toUpperCase())"></v-text-field>
              </v-col>
            </v-row>

            <v-row justify="center" v-if="error !== ''">
                <v-col cols="12" sm="12">
                    <p class="heading2 mb-0 mt-0" style="background-color: #FF00024D; color: white; border-radius: 5px; margin-top: 20px; padding: 15px 15px 15px 15px;">{{error}}</p>
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="last">
                    <v-btn block x-large
                        type="submit"
                        :color="tenantColor"
                        class="white--text"
                        @click="authorize"
                        :disabled="buttondisabled"
                        style="text-transform: none; color: #EBEBEB; font-size: 18px"
                    >
                        {{ flowType == 'AUTHORIZATION_CODE' ? print('PARTNER.VOYO.SSO_WEB.ENABLE_BTN') : flowType == 'DEVICE_CODE' ? print('PARTNER.VOYO.SSO_WEB.PAIR_BTN') : '' }}
                    </v-btn>
                </v-col>
                <v-col cols="12" sm="6" class="pt-0 pb-5" order-sm="first"><!-- class="d-none d-sm-flex" -->
                    <v-btn block x-large color="secondary" @click="redirectToPartner"
                      style="text-transform: none; color: #EBEBEB; font-size: 18px"
                    >
                        {{ flowType == 'AUTHORIZATION_CODE' ? print('PARTNER.VOYO.SSO_WEB.CANCEL') : flowType == 'DEVICE_CODE' ? print('PARTNER.VOYO.SSO_WEB.CANCEL') : '' }}
                    </v-btn>
                </v-col>
            </v-row>

        </v-col>
    </v-row>


  </v-container>
</template>

<style>
.heading1 {
    text-align: left;
    font-size: 30px;
    line-height: 1.2;
}
.heading2 {
    text-align: left;
    font-size: 18px;
    line-height: 1.2;
    letter-spacing: 0.7px;
}
.consent_checkbox {
    text-align: left;
}
.consent_description {
    text-align: left;
}

.v-text-field {
    font-size: 1.5em;
    font-weight: 100;
}

.v-btn {
    text-transform: none;
    color: #EBEBEB;
    font-size: 1.5em !important;
    letter-spacing: normal;
}

</style>

<script>
  import { api } from "../main";
  import VueCookies from 'vue-cookies'

  export default {
    name: 'LogIn',
    data: () => ({
        consents: {},
        error: '',
        user_code: '',
        language: '',
        buttondisabled: false,
        showall: false
    }),

    props: ['languagestrings', 'toperror', 'baseUrl'],

    computed: {
      flowType() {
        var flowType = VueCookies.get('flow');
        //console.log('flowType', flowType);
        return flowType;
      },
      tenant() {
        return VueCookies.get('tenant');
      },
      tenantColor() {
          return this.tenant == 'DIGI' ? '#0095DA' : '#EA0A8E'; // '#0095DA'
      },
      userCodeRule() {
        return [
          v => !!v || this.print('PARTNER.VOYO.SSO_WEB.LOGIN.QR_CODE_WARNING')
        ]
      }
    },

    methods: {

      goBack() {
          this.$router.go(-1)
      },

      redirectToPartner() {
          this.$router.push({ path: '/final', query: { result: 'false' } });
      },

      print(input_prop) {
          return api.print(this.languagestrings, input_prop);
      },

      async authorize() {
        this.buttondisabled = true;
        var data = {
          "client_id": VueCookies.get('client_id'),
          "redirect_uri": VueCookies.get('redirect_uri'),
          "scope": 'PARTNER_APP_LOGIN',
          "language": this.language,
          "state": VueCookies.get('state')
        };
        if(this.flowType == 'DEVICE_CODE') {
          data.user_code = this.user_code;
          data.approval_status = 'APPROVED'; // or DENIED
          // SIMPLE VALIDATION
          if(!this.user_code) {
            this.error = this.print('PARTNER.VOYO.SSO_WEB.LOGIN.QR_CODE_WARNING');
            this.buttondisabled = false;
            this.showall = true;
            return;
          }
        }
        if(VueCookies.isKey('code_challenge') && VueCookies.isKey('code_challenge_method')) {
          data.code_challenge = VueCookies.get('code_challenge');
          data.code_challenge_method = VueCookies.get('code_challenge_method');
        }
        const options = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + VueCookies.get('accessToken')
          },
          body: new URLSearchParams(data)
        };
        var res;
        if(this.flowType == 'AUTHORIZATION_CODE') {
          //console.log(this.baseUrl);
          //console.log(options);
          res = await api.requestData(this.baseUrl + '/oauth/internal/authorize', options);
        }
        else if(this.flowType == 'DEVICE_CODE') {
          res = await api.requestData(this.baseUrl + '/oauth/internal/authorize/device', options);
        }

        // REQUEST RESULTS ACTIONS
        if(Object.prototype.hasOwnProperty.call(res, 'status')) {
          if(res.status == 'ok' && Object.prototype.hasOwnProperty.call(res.responseBody, "redirectUrl")) {
            window.location.href = res.responseBody.redirectUrl;
          }
          else if(res.status == 'ok' && !Object.prototype.hasOwnProperty.call(res.responseBody, "redirectUrl")) {
            this.$router.push({ path: '/final' })
          }
          else {
            this.showall = true;
            if(res.responseStatus == 'ECONNRESET') {
              this.error = 'Pripojenie na server zlyhalo.';
            }
            else {
              this.error = res.responseBody.error_description;
              if (res.responseStatus == '401') {
                setTimeout(() => {this.$router.push({ path: VueCookies.get('loginPath') })}, 3000);
              }
            }              
          }
        }
        else {
          this.error = 'Pripojenie na server zlyhalo.';
        }
        this.buttondisabled = false;
      }
    },

    created: async function(){
      this.user_code = VueCookies.get('user_code') || '';
      this.language = VueCookies.get('language');
      //console.log('baseUrl', this.baseUrl);
    },

    mounted: async function() {
      this.authorize();
      /*
      var wait4parameter = setInterval(() => {
        if(typeof api.baseUrl !== 'undefined') {
          clearInterval(wait4parameter);
          this.authorize();
        }
      }, 200);
      */
    }
  }
</script>
